import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
})
export class DialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      status: 'success' | 'error' | 'warning' | 'info' | 'Failed';
      title: string;
      content: string;
      showCloseBtn: boolean;
      closeBtnText: string;
      okBtnText: string;
    }
  ) {
    if (!this.data.status) this.data.status = 'info';
    if (!this.data.title) this.data.title = 'Information';
    if (!this.data.content) this.data.content = 'No content';
    if (!this.data.showCloseBtn) this.data.showCloseBtn = false;
    if (!this.data.closeBtnText) this.data.closeBtnText = 'Close';
    if (!this.data.okBtnText) this.data.okBtnText = 'OK';
  }

  onCloseDialog(isClosed: boolean) {
    this.dialogRef.close(isClosed);
  }
}
